import { render } from "./FlexBasis.vue?vue&type=template&id=44a4f76f&scoped=true&ts=true"
import script from "./FlexBasis.vue?vue&type=script&lang=ts"
export * from "./FlexBasis.vue?vue&type=script&lang=ts"

import "./FlexBasis.vue?vue&type=style&index=0&id=44a4f76f&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a4f76f"]])

export default __exports__